/* 🤖 this file was generated by svg-to-ts */
export const matIconViewDay: {
  name: 'view-day';
  data: string;
} = {
  name: 'view-day',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 18H2v2h19v-2zm-2-8v4H4v-4h15m1-2H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm1-4H2v2h19V4z"/></svg>`
};
